export default {"src":"/_next/static/media/b6.cd4a6fcc.svg","height":65,"width":159,"blurWidth":0,"blurHeight":0};